import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import useResetPassword from "./useSendResetPasswordEmail";
import { validateEmail } from "../../../common/utils";
interface IResetPassword {
  show: boolean;
  onHide: () => void;
}

const ResetPassword = ({ show, onHide }: IResetPassword) => {
  const { email, emailError, loading, handleResetPassword, handleEmailChange } =
    useResetPassword(onHide);

  return (
    <Modal
      show={show}
      onHide={onHide}
      className="modal-container move-device-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your registered email"
              value={email}
              disabled={loading}
              onChange={handleEmailChange}
            />
            {emailError && <p style={{ color: "red" }}>{emailError}</p>}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-cancel" onClick={onHide}>
          Cancel
        </Button>
        <Button
          className="btn-style"
          onClick={handleResetPassword}
          disabled={loading || email.trim() === "" || !validateEmail(email)}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetPassword;
